var map = {
	"./arabic.svg": "54e1",
	"./balance.svg": "8f89",
	"./brazil.svg": "5c0e",
	"./exercise.svg": "bef4",
	"./faith.svg": "4f64",
	"./france.svg": "0b33",
	"./fresh-air.svg": "0ca0",
	"./german.svg": "8887",
	"./nutrition.svg": "bc83",
	"./quasar-logo-full.svg": "d3d6",
	"./rest.svg": "a8f5",
	"./sad.svg": "c4e4",
	"./spain.svg": "caa6",
	"./sun.svg": "3f73",
	"./uk.svg": "8da5",
	"./usa.svg": "e20b",
	"./water.svg": "9dc7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";